<lx-section-template [columns]="columns" [sectionTitle]="title">
  <div class="price-request-student-form__form-group">
    <lx-form-field
      i18n-label
      label="First name"
      [small]="true"
      [isValid]="formData.firstName.isValid"
      [required]="formData.firstName.required"
      [errorMessage]="formData.firstName.errorMessage"
      [iconValidation]="true"
      lxClickCounter
      (clickCount)="trackClickEvent($event)"
    >
      <input
        type="text"
        pInputText
        lxFormDataInputValidity
        [formData]="formData.firstName"
        [(ngModel)]="formData.firstName.value"
        [validationRequests]="validationRequests"
        (lxNativeAutofill)="onAutoFill()"
        (focusout)="validateField('firstName')"
        [attr.autocomplete]="'given-name'"
        lxStudentDetailsLogging="firstName"
        data-qa="qt-first-name-field"
      />
    </lx-form-field>
  </div>

  <div class="price-request-student-form__form-group">
    <lx-form-field
      i18n-label
      label="Last name"
      [small]="true"
      [isValid]="formData.lastName.isValid"
      [required]="formData.lastName.required"
      [errorMessage]="formData.lastName.errorMessage"
      [iconValidation]="true"
      lxClickCounter
      (clickCount)="trackClickEvent($event)"
    >
      <input
        type="text"
        pInputText
        lxFormDataInputValidity
        [formData]="formData.lastName"
        [(ngModel)]="formData.lastName.value"
        [validationRequests]="validationRequests"
        (lxNativeAutofill)="onAutoFill()"
        (focusout)="validateField('lastName')"
        [attr.autocomplete]="'family-name'"
        lxStudentDetailsLogging="lastName"
        data-qa="qt-last-name-field"
      />
    </lx-form-field>
  </div>

  <div class="price-request-student-form__form-group">
    <lx-form-field
      i18n-label
      label="Email address"
      [small]="true"
      [isValid]="formData.email.isValid"
      [required]="formData.email.required"
      [errorMessage]="formData.email.value | lxEmailError"
      [iconValidation]="true"
      lxClickCounter
      (clickCount)="trackClickEvent($event)"
    >
      <input
        type="email"
        pInputText
        lxFormDataEmailValidity
        [formData]="formData.email"
        lxBlockSpaces
        [(ngModel)]="formData.email.value"
        [validationRequests]="validationRequests"
        (lxNativeAutofill)="onAutoFill()"
        (focusout)="validateField('email')"
        [attr.autocomplete]="'email'"
        lxStudentDetailsLogging="email"
        data-qa="enrolment-email"
      />
    </lx-form-field>
  </div>

  <div class="price-request-student-form__form-group">
    <lx-phone-number-field
      label="Phone number"
      i18n-label
      [phoneCode]="phoneCode"
      [phoneNumber]="phoneNumber"
      [isValid]="formData.phoneNumber.isValid"
      [required]="formData.phoneNumber.required"
      [validationRequests]="validationRequests"
      (valueChange)="onSelectPhoneNumber($event)"
      lxClickCounter
      (focusout)="storeStudentDetails()"
      (clickCount)="trackClickEvent($event)"
      data-qa="qt-phone-number-field"
      lxStudentDetailsLogging="phoneNumber"
    ></lx-phone-number-field>
  </div>

  <div class="price-request-student-form__form-group">
    <lx-form-field
      class="form-field__validated-selector-padding form-field__no-border-dropdown"
      [class.form-field__no-validation]="!formData.countryOfResidence.value && formData.countryOfResidence.isValid"
      label="Country"
      i18n-label
      [small]="true"
      [isValid]="formData.countryOfResidence.isValid"
      [required]="formData.countryOfResidence.required"
      [errorMessage]="formData.countryOfResidence.errorMessage"
      [iconValidation]="true"
      lxClickCounter
      (clickCount)="trackClickEvent($event)"
    >
      <lx-residence-country-selector
        [(value)]="formData.countryOfResidence.value"
        (valueChange)="setCountryOfResidence($event)"
        lxStudentDetailsLogging="countryOfResidence"
        data-qa="qt-country-selector"
        lxFormDataDropdownValidity
        [formData]="formData.countryOfResidence"
      ></lx-residence-country-selector>
    </lx-form-field>
  </div>

  <div class="price-request-student-form__form-group">
    <lx-form-field
      i18n-label
      label="Postcode"
      [small]="true"
      [isValid]="formData.postcode.isValid"
      [required]="formData.postcode.required"
      [errorMessage]="formData.postcode.errorMessage"
      [iconValidation]="true"
      lxClickCounter
      (clickCount)="trackClickEvent($event)"
    >
      <input
        type="text"
        pInputText
        lxFormDataPostcodeValidity
        [formData]="formData.postcode"
        [(ngModel)]="formData.postcode.value"
        [validationRequests]="validationRequests"
        (lxNativeAutofill)="onAutoFill()"
        (focusout)="validateField('postcode')"
        [attr.autocomplete]="'postal-code'"
        lxStudentDetailsLogging="postcode"
        data-qa="qt-postcode-field"
      />
    </lx-form-field>
  </div>

  <div class="price-request-student-form__form-group">
    <lx-date-of-birth-field
      lxFormDataCustomComponentValidity
      [formData]="formData.dateOfBirth"
      [validationRequests]="validationRequests"
      #validity="lxFormDataCustomComponentValidity"
      [isValid]="(validity.enabledValidation$ | async) ? formData.dateOfBirth.isValid : null"
      [required]="formData.dateOfBirth.required"
      [errorMessage]="formData.dateOfBirth.errorMessage"
      [date]="preselectedDateOfBirth"
      (dateChange)="onSelectBirthDate($event)"
      (focusout)="validateField('dateOfBirth')"
      lxClickCounter
      (clickCount)="trackClickEvent($event)"
      data-qa="qt-date-of-birth-field"
      lxStudentDetailsLogging="dateOfBirth"
    ></lx-date-of-birth-field>
  </div>

  <div class="price-request-student-form__form-group" *ngIf="withNationalityField">
    <lx-nationality-selector
      label="Nationality"
      i18n-label
      (valueChange)="onSelectNationality($event)"
      [(value)]="formData.nationality.value"
      [isValid]="formData.nationality.isValid"
      [required]="formData.nationality.required"
      [small]="true"
      lxClickCounter
      (clickCount)="trackClickEvent($event)"
      data-qa="qt-nationality-field"
      lxStudentDetailsLogging="nationality"
    ></lx-nationality-selector>
  </div>
</lx-section-template>

<lx-terms-and-promotions-form-section (agreeToPromotionsChanged)="updateAgreeToPromotions($event)"></lx-terms-and-promotions-form-section>
